export const baseURL = "/api";
export const GOOGLEID =
  "808615392749-rk1a470v1s4ob47bn2bmd7jh6ou6dd94.apps.googleusercontent.com";
